var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaProfileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 73 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-profile-icon_svg__a",
    d: "M0 70h72.414V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.172 33.793c0 17.997-14.589 32.586-32.586 32.586S0 51.79 0 33.793 14.589 1.207 32.586 1.207s32.586 14.589 32.586 32.586",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M56.724 32.586V1.206H42.241V15.69h-15.69v50.69h44.656V32.585z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.241 67.586h-3.62a1.207 1.207 0 110-2.414h3.62a1.207 1.207 0 110 2.414M26.551 37.414c-.667 0-1.206-.541-1.206-1.207V15.689c0-.666.54-1.206 1.206-1.206h15.69a1.207 1.207 0 110 2.413H27.758v19.31c0 .667-.54 1.208-1.207 1.208",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ea-profile-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-profile-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.448 65.172h12.07V2.414h-12.07v62.758zm13.276 2.414H42.241c-.667 0-1.207-.54-1.207-1.207V1.207c0-.666.54-1.207 1.207-1.207h14.483c.668 0 1.207.54 1.207 1.207v65.172c0 .667-.54 1.207-1.207 1.207z",
    fill: "#020303",
    mask: "url(#ea-profile-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.207 67.586H56.724a1.207 1.207 0 110-2.414H70v-31.38H56.724a1.207 1.207 0 110-2.413h14.483c.667 0 1.207.54 1.207 1.207v33.793c0 .666-.54 1.207-1.207 1.207",
    fill: "#020303",
    mask: "url(#ea-profile-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.793 57.57c0-1.835-5.316-4.466-9.659-4.466-4.34-.001-9.651 2.631-9.651 4.467v7.962c0 1.835 5.31 4.467 9.651 4.467 4.343 0 9.66-2.632 9.66-4.467V57.57z",
    fill: "#E74B0F",
    mask: "url(#ea-profile-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.793 66.38c-.668 0-1.207-.542-1.207-1.208v-7.6c-.22-.89-4.434-3.262-8.452-3.262-4.015 0-8.225 2.372-8.447 3.295l.002 7.567a1.207 1.207 0 11-2.413 0v-7.6c0-3.078 6.669-5.676 10.858-5.676 4.192 0 10.866 2.598 10.866 5.675v7.601c0 .666-.54 1.207-1.207 1.207",
    fill: "#020303",
    mask: "url(#ea-profile-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.138 41.034c-2.496 0-4.828 1.946-4.828 4.347v3.376c0 2.4 2.332 4.346 4.828 4.346 2.496 0 4.828-1.945 4.828-4.346v-3.376c0-2.401-2.332-4.347-4.828-4.347",
    fill: "#FEFEFE",
    mask: "url(#ea-profile-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.138 42.241c-1.895 0-3.621 1.497-3.621 3.14v3.376c0 1.643 1.726 3.14 3.62 3.14 1.896 0 3.621-1.497 3.621-3.14V45.38c0-1.642-1.725-3.139-3.62-3.139m0 12.07c-3.271 0-6.035-2.544-6.035-5.554V45.38c0-3.01 2.764-5.553 6.035-5.553 3.27 0 6.034 2.543 6.034 5.553v3.377c0 3.01-2.764 5.553-6.034 5.553",
    fill: "#020303",
    mask: "url(#ea-profile-icon_svg__b)"
  }))));
}
export default SvgEaProfileIcon;